import React from 'react';

const StepHeader = ({ title, step, totalSteps, progress }) => {
  return (
    <>
      <div className="solicitor-panel-checker-form__header">
        <div className="solicitor-panel-checker-form__title-row">
          <h6 className="solicitor-panel-checker-form__title">{title}</h6>
          <span className="solicitor-panel-checker-form__progress-text">
           | Step {step} of {totalSteps}
          </span>
        </div>
      </div>

      <div className="solicitor-panel-checker-form__progress">
        <div className="solicitor-panel-checker-form__progress-bar">
          <div 
            className="solicitor-panel-checker-form__progress-fill" 
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </>
  );
};

export default StepHeader;
